<mat-dialog-content>
  <p>{{ message }}</p>

  <mat-checkbox
    (ngModelChange)="onCheckboxChange($event)"
    [ngModel]="isConfirmed()">
    {{ checkboxLabel }}
  </mat-checkbox>
</mat-dialog-content>
